<cb-dialog dialogHeading="Import Errors">
    <div ng-show="$ctrl.takeOffResult.hasErrors">
        <span class="mat-body-strong">
            <mat-icon class="mat-warn">warning</mat-icon>
            &nbsp;Please fix the following errors and Retry
        </span>
    </div>
    <div class="standardTable scrollable-container mat-body-2">
        <table>
            <thead>
                <tr>
                    <td>Row</td>
                    <td>Column</td>
                    <td>Message</td>
                </tr>
            </thead>
            <tbody>
                @for (error of takeOffResult.errors; track error) {
                    <tr>
                        <td>{{ error.rowNumber | cbDasher }}</td>
                        <td>{{ error.columnNumber | cbDasher }}</td>
                        <td>{{ error.message | cbDasher }}</td>
                    </tr>
                }
                @if (takeOffResult.errors && takeOffResult.errors.length < 1) {
                    <tr>
                        <td>
                            <mat-icon class="mat-info">warning</mat-icon>
                            &nbsp;There are no errors.
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
    <div actions>
        <button mat-raised-button color="primary" (click)="getTransferHistoryErrors()">
            Download error list
        </button>
        <button mat-raised-button color="primary" (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
